import styled from 'styled-components'

export const OrderedList = styled.ol`
	display: flex;
	flex-direction: column;
	row-gap: 2px;
	margin: 0;
	padding: 0;
	list-style-type: none;
	font-weight: 500;
`
